/**
 * Écarter les journées pédagogiques d'une requête sur `sessions`.
 *
 * Les écrans de stages — tableau de bord, présences, groupes, rapports… — ne
 * doivent voir que les stages et les plaines (décision du 24/10/2026, JPA13).
 * Le filtre porte sur `stage_id`, côté serveur : un compte exact ou une
 * limite restent justes, et il ne demande pas de jointure `stages!inner`, que
 * la politique de lecture des stages ferait échouer pour un animateur sur un
 * stage inactif.
 */

import { db } from '../payments/db';
import { TYPE_JPA } from './regles';

export { sansJpa } from './regles';

let lecture: Promise<string[]> | null = null;

/**
 * Les fiches de stage des journées pédagogiques — une seule aujourd'hui,
 * « Journée pédagogique animée » —, lues une fois par chargement de l'application.
 */
export function stagesDesJpa(): Promise<string[]> {
  if (!lecture) {
    lecture = (async () => {
      const { data, error } = await db.from('stages').select('id').eq('type_activite', TYPE_JPA);
      if (error) throw error;
      return ((data ?? []) as { id: string }[]).map((s) => s.id);
    })();
    // Une lecture ratée se retente au prochain écran plutôt que de rester en échec.
    lecture.catch(() => { lecture = null; });
  }
  return lecture;
}
